import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export interface MessageStatusAtom {
    create: StatusType,
};

export const messageStatusAtom = atom<MessageStatusAtom>({
    key: 'messageStatusAtom',
    default: {
        create: 'idle'
    }
});
